module.exports = __webpack_public_path__ + "img/chinesecompany26.873b36d0.png";